var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',[_c('v-container',[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',[_c('iframe',{staticStyle:{"border":"none"},attrs:{"src":'https://app.aadalentruck.no/public/report/dagligkontroll?lang=' +
							_vm.$i18n.locale,"width":"100%","height":"940px;","scrolling":"no"}})])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }